<div class="custom-box" *ngIf="isDataAvailable()">
    <section class="blue-theme">
        <div class="scroll row grid">
            <div class="col-lg-11  gst-section mb3">
                <div class="col-xs-12 col-md-6 col-lg-4 card solution_card">
                    <div class="hover_color_bubble"></div>
                    <div class="">
                        <!-- <span class="circle-icon1 circle1"><img src="content/images/Tax Legislation.svg" class="img-fluid"></span> -->
                        <span *ngFor="let taxLeg of taxLegislationList;let i = index">
                            <cbic-static-text *ngIf="i== 0" class="Header" [textEn]="taxLeg.contentType?.titleEn"
                                [textHi]="taxLeg.contentType?.titleHi"></cbic-static-text>
                        </span>
                    </div>
                    <ul class="custom-scroll-bar">
                        <li *ngFor="let taxLeg of taxLegislationList">
                            <a href="{{taxLeg.path}}" target="_blank"></a>
                                <cbic-link [linkTextEn]="taxLeg.titleEn" [linkTextHi]="taxLeg.titleHi"
                                    [linkEn]="taxLeg.path" [linkHi]="taxLeg.path"></cbic-link>
                        </li>
                    </ul>
                </div>

                <div class="col-xs-12 col-md-6 col-lg-4 card solution_card solution_card ">
                    <div class="hover_color_bubble"></div>
                    <div class=" ">
                        <!-- <div class="circle-icon1 circle1"> <img src="content/images/Onlines Services.svg" class="img-fluid"></div> -->
                                <span *ngFor="let onlineService of onlineServiceList;let i = index">
                                    <cbic-static-text *ngIf="i== 0" class="Header" [textEn]="onlineService.contentType?.titleEn"
                                        [textHi]="onlineService.contentType?.titleHi"></cbic-static-text>
                                </span>
                    </div>
                    <ul class="custom-scroll-bar">
                            <li *ngFor="let onlineService of onlineServiceList">
                                <cbic-link [linkTextEn]="onlineService.titleEn" [linkTextHi]="onlineService.titleHi"
                                        [linkEn]="onlineService.path" [linkHi]="onlineService.path"></cbic-link>
                            </li>
                    </ul>
                </div>
                <div class="col-xs-12 col-md-6 col-lg-4 card solution_card solution_card ">
                    <div class="hover_color_bubble"></div>
                    <div class=" ">
                        <!-- <div class="circle-icon1 circle1"><img src="content/images/tarrif.png" class="img-fluid"></div> -->
                        <span *ngFor="let tariff of tariffList;let i = index">
                            <cbic-static-text *ngIf="i== 0" class="Header" [textEn]="tariff.contentType?.titleEn"
                                [textHi]="tariff.contentType?.titleHi"></cbic-static-text>
                        </span>
                    </div>
                    <ul class="custom-scroll-bar">
                        <li *ngFor="let tariff of tariffList">
                            <cbic-link [linkTextEn]="tariff.titleEn" [linkTextHi]="tariff.titleHi"
                                [linkEn]="tariff.path" [linkHi]="tariff.path"></cbic-link>
                        </li>
                    </ul>
                </div>
            </div>
            <!---first row ends here-->
            <!---second row start-->
            <div class="col-lg-11  gst-section ">
                <div class="col-xs-12 col-md-6 col-lg-4 card solution_card solution_card">
                    <div class="hover_color_bubble"></div>
                    <div class="">
                        <!-- <div class="circle-icon1 circle1"><img src="content/images/Manuals.svg" class="img-fluid"></div> -->
                        <span *ngFor="let customs of customsmanualList;let i = index">
                            <cbic-static-text *ngIf="i== 0" class="Header" [textEn]="customs.contentType?.titleEn"
                                [textHi]="customs.contentType?.titleHi"></cbic-static-text>
                        </span>
                    </div>
                    <ul class="custom-scroll-bar">
                        <li *ngFor="let customs of customsmanualList">
                            <cbic-link [linkTextEn]="customs.titleEn" [linkTextHi]="customs.titleHi"
                                    [linkEn]="customs.path" [linkHi]="customs.path"></cbic-link>
                        </li>
                    </ul>

                </div>
                <div class="col-xs-12 col-md-6 col-lg-4 card solution_card solution_card">
                    <div class="hover_color_bubble"></div>
                    <div class=" ">
                        <!-- <div class="circle-icon1 circle1"><img src="content/images/Tax Legislation.svg"class="img-fluid"></div> -->
                                
                        <span *ngFor="let caseLow of caseLowsList;let i = index">
                            <cbic-static-text *ngIf="i== 0" class="Header" [textEn]="caseLow.contentType?.titleEn"
                                [textHi]="caseLow.contentType?.titleHi"></cbic-static-text>
                        </span>
                    </div>
                    <ul class="custom-scroll-bar">
                        <li *ngFor="let caseLow of caseLowsList">
                            <cbic-link [linkTextEn]="caseLow.titleEn" [linkTextHi]="caseLow.titleHi"
                                    [linkEn]="caseLow.path" [linkHi]="caseLow.path"></cbic-link>
                        </li>
                    </ul>
                </div>
                <div class="col-xs-12 col-md-6 col-lg-4 card solution_card solution_card">
                    <div class="hover_color_bubble"></div>
                    <div class="">
                        <!-- <div class="circle-icon1 circle1"><img src="content/images/Others.svg" class="img-fluid"></div> -->
                        <span *ngFor="let misService of customsMiscellaneousList;let i = index">
                            <cbic-static-text *ngIf="i== 0" class="Header" [textEn]="misService.contentType?.titleEn"
                                [textHi]="misService.contentType?.titleHi"></cbic-static-text>
                        </span>
                    </div>
                    <ul class="custom-scroll-bar">
                        <li *ngFor="let misService of customsMiscellaneousList">
                            <cbic-link [linkTextEn]="misService.titleEn" [linkTextHi]="misService.titleHi"
                                    [linkEn]="misService.path" [linkHi]="misService.path"></cbic-link>
                        </li>
                    </ul>
                </div>
            </div>

        </div>

    </section>
</div>